module.exports = __webpack_public_path__ + "static/media/16-12.1bde46f5.mp3";